<!--  title -->
<template>
  <div class="scroll-view" :class="$isPc?'':'is-ios'">
    <slot></slot>
  </div>
</template>
<script>
export default {
  name: 'scroll-view'
}
</script>
<style lang="stylus" scoped>

.scroll-view
  overflow-y auto
  overflow-x auto
  margin 10px
  padding 10px
  height 400px

.scroll-view.is-ios
  height 300px

</style>
